module.exports = __webpack_public_path__ + "e64cab512db37dc0cc21be41a670ea64.pdf";